import React from 'react';

export default function CVSHealth({ ...props }) {
  return (
    <svg
      width="144"
      height="19"
      viewBox="0 0 144 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M5.09483 1.32272C5.58895 0.825663 6.2342 0.578132 6.88043 0.578132C7.52866 0.578132 8.17629 0.826661 8.66942 1.32372L11.6103 4.27613L14.5462 1.32771C15.0423 0.828658 15.6895 0.57913 16.3378 0.57913C16.983 0.57913 17.6282 0.826661 18.1224 1.32472L21.6926 4.90993C22.6794 5.90005 22.6814 7.50701 21.6942 8.49713L11.6099 18.621L1.52562 8.49713C0.537372 7.50601 0.537372 5.89805 1.52164 4.90993L5.09483 1.32272Z"
        fill="#10284B"
      />
      <path
        d="M45.6948 1.03427H40.1203L45.831 18.1419H51.2683L57.001 1.03427H51.6322L48.5611 12.0893L45.6948 1.03427Z"
        fill="#10284B"
      />
      <path
        d="M33.1359 18.621C38.0275 18.621 40.9852 15.9949 41.2805 11.4955H36.1166C35.9565 13.322 34.9106 14.3271 33.2493 14.3271C31.0431 14.3271 29.8829 12.7062 29.8829 9.60004C29.8829 6.42506 30.9517 4.84904 33.0902 4.84904C34.842 4.84904 35.8203 5.76231 35.9794 7.49802H41.19C40.8709 3.06742 37.9589 0.555176 33.0226 0.555176C27.7215 0.555176 24.3769 4.00364 24.3769 9.60004C24.3769 15.1495 27.6986 18.621 33.1359 18.621Z"
        fill="#10284B"
      />
      <path
        d="M63.872 14.5337C62.3707 14.5337 61.6429 14.0766 61.3695 12.797H56.0455C56.3865 16.4511 59.0719 18.621 63.6443 18.621C68.5815 18.621 71.243 16.4511 71.243 12.7291C71.243 10.9704 70.561 9.73678 69.0587 8.73169C68.1524 8.11214 66.8043 7.77178 65.1254 7.34788C64.8244 7.27189 64.5127 7.19321 64.1911 7.10976C64.0715 7.07815 63.956 7.048 63.8445 7.01891C62.4278 6.64926 61.6648 6.45017 61.6648 5.60261C61.6648 4.82608 62.2345 4.43782 63.3947 4.43782C64.7141 4.43782 65.4189 4.91791 65.6009 5.94596H70.7658C70.4695 2.4965 67.8766 0.555176 63.4852 0.555176C58.9576 0.555176 56.3647 2.70211 56.3647 6.01383C56.3647 7.70363 57.001 9.02912 58.3213 9.96435C59.0262 10.4674 60.5503 10.9934 62.9165 11.6092C63.1689 11.6748 63.405 11.7336 63.625 11.7884C65.1704 12.1731 65.92 12.3598 65.92 13.299C65.92 14.0536 65.1913 14.5337 63.872 14.5337Z"
        fill="#10284B"
      />
      <path
        d="M122.866 18.1652C122.617 18.257 122.117 18.3249 121.798 18.3249C119.75 18.3249 118.908 17.206 118.908 15.0811V2.58872H117.316V1.03467H120.819V14.9902C120.819 16.2698 121.206 16.703 122.025 16.703C122.276 16.703 122.548 16.68 122.866 16.6122V18.1652Z"
        fill="#10284B"
      />
      <path
        d="M126.53 7.88669V15.105C126.53 16.3606 126.984 16.703 127.941 16.703C128.236 16.703 128.554 16.68 128.918 16.6122V18.1652C128.646 18.257 128.1 18.3249 127.759 18.3249C125.552 18.3249 124.619 17.2969 124.619 15.1958V7.88669H122.799V6.33363H124.619V3.31934H126.53V6.33363H128.918V7.88669H126.53Z"
        fill="#10284B"
      />
      <path
        d="M133.491 16.6122H135.084V18.1652H129.988V16.6122H131.581V2.58872H129.988V1.03467H133.491V7.65912C134.288 6.63107 135.517 5.99128 137.177 5.99128C140.362 5.99128 142.114 8.36678 142.114 11.3132V16.6122H143.707V18.1652H138.611V16.6122H140.203V11.3132C140.203 8.84687 138.929 7.6132 136.949 7.6132C134.743 7.6132 133.491 8.84687 133.491 11.3132V16.6122Z"
        fill="#10284B"
      />
      <path
        d="M76.5242 2.63364V8.18412H85.0783V2.63364H83.3723V1.03467H88.7639V2.63364H87.0578V16.5662H88.7639V18.1652H83.3723V16.5662H85.0783V9.73718H76.5242V16.5662H78.2302V18.1652H72.8386V16.5662H74.5447V2.63364H72.8386V1.03467H78.2302V2.63364H76.5242Z"
        fill="#10284B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.4566 14.9902H101.367C100.435 17.1601 98.3868 18.5076 95.7253 18.5076C92.0855 18.5076 89.5602 15.9494 89.5602 12.2494C89.5602 8.57239 92.0855 5.99128 95.7253 5.99128C99.3433 5.99128 101.641 8.43565 101.641 12.0438V12.8892H91.5168C91.6988 15.2867 93.1314 16.9086 95.7939 16.9086C97.5457 16.9086 98.7736 16.178 99.4566 14.9902ZM99.729 11.3591C99.5242 9.37187 98.2278 7.59025 95.7253 7.59025C93.2 7.59025 91.7445 9.18922 91.5168 11.3591H99.729Z"
        fill="#10284B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.634 18.1652H113.13V16.4065C112.129 17.7081 110.627 18.5076 108.852 18.5076C105.508 18.5076 103.029 15.8127 103.029 12.2494C103.029 8.68617 105.508 5.99128 108.852 5.99128C110.627 5.99128 112.129 6.79076 113.13 8.0923V6.33363H116.634V7.88669H115.041V16.6122H116.634V18.1652ZM109.102 7.6132C106.691 7.6132 104.984 9.55453 104.984 12.2494C104.984 14.9443 106.691 16.8866 109.102 16.8866C111.537 16.8866 113.198 14.8984 113.198 12.2494C113.198 9.59944 111.537 7.6132 109.102 7.6132Z"
        fill="#10284B"
      />
    </svg>
  );
}
